module.exports = __webpack_public_path__ + "static/media/battery-testing.9ed94ff1.svg";